import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './components/home/home.component';
import { AuthComponent } from './components/auth/auth.component';
import { VerifyComponent } from './components/auth/components/verify/verify.component';
import { ResetPasswordComponent } from './components/auth/components/reset-password/reset-password.component';
import { ProfileComponent } from './components/profile/profile.component';
import { InstructionsComponent } from './components/instructions/instructions.component';
import { IdeaListComponent } from './components/idea-list/idea-list.component';
import { IdeaListMyComponent } from './components/idea-list-my/idea-list-my.component';
import { IdeaDetailsComponent } from './components/idea-details/idea-details.component';
import { IdeaCreateComponent } from './components/idea-create/idea-create.component';
import { CategoryListComponent } from './components/category-list/category-list.component';
import { CategoryDetailsComponent } from './components/category-details/category-details.component';
import { AuthorListComponent } from './components/author-list/author-list.component';
import { AuthorDetailsComponent } from './components/author-details/author-details.component';

import { AuthGuard } from './services/auth-guard.service';
import { SessionDataResolver } from './services/session-data-resolver.service';
import { AdminComponent } from './components/admin/admin.component';
import { AdminIdeaNewComponent } from './components/admin/components/admin-idea-new/admin-idea-new.component';
import { AdminIdeaDefectedComponent } from './components/admin/components/admin-idea-defected/admin-idea-defected.component';
import { AdminIdeaInDiscussionComponent } from './components/admin/components/admin-idea-in-discussion/admin-idea-in-discussion.component';
import { AdminIdeaCurrentComponent } from './components/admin/components/admin-idea-current/admin-idea-current.component';
import { AdminIdeaCompletedComponent } from './components/admin/components/admin-idea-completed/admin-idea-completed.component';
import { AdminIdeaFailedComponent } from './components/admin/components/admin-idea-failed/admin-idea-failed.component';
import { AdminIdeaAgreedComponent } from './components/admin/components/admin-idea-agreed/admin-idea-agreed.component';
import { AdminIdeaRejectedComponent } from './components/admin/components/admin-idea-rejected/admin-idea-rejected.component';
import { AdminIdeaBlockedComponent } from './components/admin/components/admin-idea-blocked/admin-idea-blocked.component';
import { AdminIdeaWaitDecisionComponent } from './components/admin/components/admin-idea-wait-decision/admin-idea-wait-decision.component';
import { AdminIdeaSentDiscussComponent } from './components/admin/components/admin-idea-sent-discuss/admin-idea-sent-discuss.component';
import { AdminIdeaAllComponent } from './components/admin/components/admin-idea-all/admin-idea-all.component';
import { PetitionDetailsComponent } from './components/admin/components/shared/petition-details/petition-details.component';
import { ForbiddenComponent } from './components/admin/components/forbidden/forbidden.component';
import { SelectMunicipalityComponent } from './select-municipality/select-municipality.component';
import { AdminIdeaMyArchiveComponent } from './components/admin/components/admin-idea-my-archive/admin-idea-my-archive.component';
import { AdminIdeaResponseComponent } from './components/admin/components/admin-idea-response/admin-idea-response.component';
import { AdminIdeaInDiscussComponent } from './components/admin/components/admin-idea-in-discuss/admin-idea-in-discuss.component';
import { AdminIdeaResponseModeComponent } from './components/admin/components/admin-idea-response-mode/admin-idea-response-mode.component';
import { CategoriesPanelComponent } from './components/admin/components/categories-panel/categories-panel.component';
import { ConfigPanelComponent } from './components/admin/components/config-panel/config-panel.component';
import { RedirectFromAppsComponent } from './components/admin/components/shared/redirect-from-apps/redirect-from-apps.component';
import { AdminAuthGuard } from './components/admin/guards/admin-auth.guard';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'home' },
  { path: 'home', component: HomeComponent },

  { path: 'auth', component: AuthComponent },
  { path: 'auth/verify/:token', component: VerifyComponent },
  { path: 'auth/reset-password', component: ResetPasswordComponent },
  { path: 'auth/reset-password/:token', component: ResetPasswordComponent },

  {
    path: 'admin',
    component: AdminComponent,
    canActivate: [AdminAuthGuard],
    children: [
      { path: '', redirectTo: 'idea-new', pathMatch: 'full' },
      { path: 'idea-new', component: AdminIdeaNewComponent },
      { path: 'idea-defected', component: AdminIdeaDefectedComponent },
      { path: 'idea-in-discussion', component: AdminIdeaInDiscussionComponent },
      { path: 'idea-in-discuss', component: AdminIdeaInDiscussComponent },
      { path: 'idea-current', component: AdminIdeaCurrentComponent },
      { path: 'idea-completed', component: AdminIdeaCompletedComponent },
      { path: 'idea-failed', component: AdminIdeaFailedComponent },
      { path: 'idea-agreed', component: AdminIdeaAgreedComponent },
      { path: 'idea-rejected', component: AdminIdeaRejectedComponent },
      { path: 'idea-blocked', component: AdminIdeaBlockedComponent },
      { path: 'idea-my-archive', component: AdminIdeaMyArchiveComponent },
      { path: 'idea-response', component: AdminIdeaResponseComponent },
      { path: 'idea-response-mode', component: AdminIdeaResponseModeComponent },
      { path: 'idea-wait-decision', component: AdminIdeaWaitDecisionComponent },
      { path: 'idea-sent-discuss', component: AdminIdeaSentDiscussComponent },
      { path: 'idea-all', component: AdminIdeaAllComponent },
      {
        path: 'petition-details/:idea-id',
        component: PetitionDetailsComponent
      },
      {
        path: 'categories',
        component: CategoriesPanelComponent
      },
      {
        path: 'config',
        component: ConfigPanelComponent
      },
      {
        path: 'session',
        component: RedirectFromAppsComponent
      }
    ]
  },

  { path: 'instructions', component: InstructionsComponent },
  { path: 'idea-list', component: IdeaListComponent },
  {
    path: 'idea-details/:id',
    component: IdeaDetailsComponent,
    resolve: {
      sessionData: SessionDataResolver
    }
  },
  { path: 'category-list', component: CategoryListComponent },
  { path: 'category-details/:id', component: CategoryDetailsComponent },
  { path: 'author-list', component: AuthorListComponent },
  { path: 'author-details/:id', component: AuthorDetailsComponent },
  {
    path: 'profile',
    component: ProfileComponent,
    canActivate: [AuthGuard],
    resolve: {
      sessionData: SessionDataResolver
    }
  },
  {
    path: 'idea-list-my',
    component: IdeaListMyComponent,
    // canActivate: [AuthGuard],
    resolve: {
      sessionData: SessionDataResolver
    }
  },
  {
    path: 'idea-create',
    component: IdeaCreateComponent,
    canActivate: [AuthGuard],
    resolve: {
      sessionData: SessionDataResolver
    }
  },

  { path: 'select-municipality', component: SelectMunicipalityComponent },

  { path: 'forbidden', component: ForbiddenComponent },

  { path: '**', redirectTo: '/home', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/app-routing.module.ts